export function addProductsState(state, payload) {
  if (payload.length) {
    return {
      ...state,
      products: [...state.products, ...payload]
    };
  } else {
    return state;
  }
}

export function replaceProductsState(state, payload) {
  if (payload.length) {
    const [product] = payload;

    return {
      ...state,
      products: [product]
    };
  } else {
    return state;
  }
}

export function setProductsState(state, payload) {
  if (payload.length) {
    return {
      ...state,
      products: payload
    };
  } else {
    return state;
  }
}

export function setProductQuantity(state, payload) {
  const { productId, quantity } = payload;

  if (!state.products.length) {
    return { ...state };
  }

  return {
    ...state,
    products: state.products.map((product) => {
      // TODO: Sorry, we need to nail down a specific product schema product_id and productId are the same
      if (productId !== product.product_id && productId !== product.productId) {
        return product;
      }

      if (product.qty) {
        // TODO: We need to nail down a specific product schema - let's favor quantity over qty
        const { ...updateProduct } = product;
        updateProduct.quantity = quantity;
        return updateProduct;
      }

      product.quantity = quantity;
      return product;
    })
  };
}
